import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Heading' })(() => ({
  root: {
    paddingBottom: 'var(--ebl-s3)',
  },
}));
